import { render } from "./FileSize.vue?vue&type=template&id=8e667e5e&ts=true"
import script from "./FileSize.vue?vue&type=script&lang=ts"
export * from "./FileSize.vue?vue&type=script&lang=ts"

import "./FileSize.vue?vue&type=style&index=0&id=8e667e5e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__